import { styled, Typography } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import Modal, { Content } from 'components/Modal';
import TertiaryButton from 'components/TertiaryButton';
import ErrorIcon from '@mui/icons-material/Error';
import Loader from 'components/Loader';

export const StyledModal = styled(Modal)`
  // required for loading wrapper on xs mobiles
  .MuiDialog-container > .MuiPaper-root {
    ${theme.breakpoints.down('sm')} {
      width: 90%;
    }
  }
`;

export const StyledContent = styled(Content)`
  padding-top: 2rem;

  h2 {
    margin-bottom: 2rem;
    text-align: center;
  }

  &.MuiCardContent-root {
    padding-bottom: 0.5rem;
  }
`;

export const StyledTertiaryButton = styled(TertiaryButton)`
  margin-top: 1rem;
`;

export const PurchaseSummary = styled('div')`
  background: ${theme.palette.neutral.light};
  border-radius: ${theme.radius.sm};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
`;

export const SummaryText = styled(Typography)``;

export const Message = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: 300px;
  justify-content: space-between;
`;

export const StyledErrorIcon = styled(ErrorIcon)`
  color: ${theme.palette.error.main};
  font-size: 56px;
  margin-bottom: 2rem;
`;

export const StyledBox = styled('div')`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

export const Spinner = styled(Loader)`
  position: absolute;
  top: 210px;
`;
